export const ReadmissionOptions = [
    { name: 'ReadmissionWithin24Hours', description: 'Readmission Within 24 Hours After Discharge' },
    { name: 'ReadmissionWithin30Days', description: 'Readmission Within 30 Days After Discharge' },
    { name: 'ReadmissionWithin90Days', description: 'Readmission Within 90 Days After Discharge' },
    { name: 'Other', description: 'Other' },
];
